import React from 'react';
import { PER_ROW_LESS } from '../../constants/perRowKeys';
import { nbItemsPerPage } from '../../configs';
import { ProductCardSkeleton } from '../../../Components/react/ProductCardVNode';
const arr = [...Array(nbItemsPerPage + 1)];
export const ItemsSkeleton = ({ perRow }) => {
    const perRowClass = perRow === PER_ROW_LESS
        ? 'gtc:1 gtc:2:md-up gtc:3:lg-up'
        : 'gtc:2 gtc:3:md-up gtc:4:lg-up';
    return (React.createElement("ul", { "data-cy-test": 'CollectionItemsList-Skeleton', className: `list:none d:grid rgap:20 cgap:16 mb:40 rgap:28:lg-up cgap:36:lg-up ${perRowClass}` }, arr.map((v, i) => (React.createElement("li", { key: i, style: { order: 1 } },
        React.createElement(ProductCardSkeleton, null))))));
};
